import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './ui/components/App';
import './index.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/700.css';
import { Toaster } from 'sonner';
import { isStaleChunkLoadError, showAppUpdatedBanner } from './lib/appRefresh';

window.addEventListener('unhandledrejection', (event) => {
  if (isStaleChunkLoadError(event.reason)) {
    event.preventDefault();
    showAppUpdatedBanner();
  }
});

window.addEventListener('error', (event) => {
  if (isStaleChunkLoadError(event.error ?? event.message)) {
    event.preventDefault();
    showAppUpdatedBanner();
  }
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
    <Toaster 
      position="top-right" 
      toastOptions={{ 
        style: { 
          background: 'hsl(0 0% 10%)', 
          color: 'hsl(0 0% 98%)', 
          border: '1px solid hsl(0 0% 20%)' 
        } 
      }} 
    />
  </StrictMode>,
);
